import { Box } from '@rbilabs/universal-components';

export default Box;
